import { Controller } from 'stimulus'
import './component.scss'

// 共通画像ディレクトリから参照
import 'Images/nurikae_site/staff_introduction/819_arai_sora.webp'
import 'Images/nurikae_site/staff_introduction/819_arai_kaneyasu.webp'
import 'Images/nurikae_site/staff_introduction/819_yokoyama.webp'
import 'Images/nurikae_site/staff_introduction/831_sunada.webp'
import 'Images/nurikae_site/staff_introduction/1651_asami.jpg'
import 'Images/nurikae_site/staff_introduction/1651_ikeda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kanto.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kida.jpg'
import 'Images/nurikae_site/staff_introduction/1651_koyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kuroda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_moriyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_obuchi.jpg'
import 'Images/nurikae_site/staff_introduction/1651_oigawa.jpg'
import 'Images/nurikae_site/staff_introduction/1997_ninomiya.webp'
import 'Images/nurikae_site/staff_introduction/1997_odate.webp'
import 'Images/nurikae_site/staff_introduction/1997_ozawa.webp'
import 'Images/nurikae_site/staff_introduction/1997_sato.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirai.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirakura.webp'
import 'Images/nurikae_site/staff_introduction/1997_yamakawa.webp'
import 'Images/nurikae_site/staff_introduction/2075_kamishita.webp'
import 'Images/nurikae_site/staff_introduction/2290_chuma.webp'
import 'Images/nurikae_site/staff_introduction/390_iwabuchi.webp'
import 'Images/nurikae_site/staff_introduction/390_tomaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ariga.jpg'
import 'Images/nurikae_site/staff_introduction/3737_fuchu.jpg'
import 'Images/nurikae_site/staff_introduction/3737_hanyu.webp'
import 'Images/nurikae_site/staff_introduction/3737_imai.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ishida.jpg'
import 'Images/nurikae_site/staff_introduction/3737_kokubun.webp'
import 'Images/nurikae_site/staff_introduction/3737_kono.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_s.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_y.jpg'
import 'Images/nurikae_site/staff_introduction/3737_okada.jpg'
import 'Images/nurikae_site/staff_introduction/3737_rikimaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sato.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sekine.jpg'
import 'Images/nurikae_site/staff_introduction/3737_yamaguchi.webp'
import 'Images/nurikae_site/staff_introduction/3737_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4611_usui.webp'
import 'Images/nurikae_site/staff_introduction/4611_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4834_harada.webp'
import 'Images/nurikae_site/staff_introduction/5089_hanawa.webp'
import 'Images/nurikae_site/staff_introduction/5089_miyanaga.webp'
import 'Images/nurikae_site/staff_introduction/5325_nakamura.webp'
import 'Images/nurikae_site/staff_introduction/5325_sano.webp'
import 'Images/nurikae_site/staff_introduction/5594_kobayashi.webp'

import Splide from '@splidejs/splide'

class StaffIntroductionController extends Controller {
  static targets = [
    'carousel',
    'sliderPrev',
    'sliderNext',
    'scrollbarThumb',
    'modal',
    'modalOverlay',
    'modalClose',
    'modalPrev',
    'modalNext',
    'modalSlide',
    'card'
  ]

  static values = {
    total: Number
  }

  connect() {
    this.currentIndex = 0
    this.initSlider()
    this.updateModalArrows()
  }

  initSlider() {
    if (!this.hasCarouselTarget) return

    this.splide = new Splide(this.carouselTarget, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: 8,
      pagination: false,
      arrows: false,
      drag: false,
      speed: 300,
      easing: 'ease'
    })

    this.splide.mount()

    this.maxSliderIndex = this.splide.Components.Controller.getEnd()

    this.splide.on('move', (newIndex) => {
      this.updateSliderArrows(newIndex)
      this.updateScrollbar(newIndex)
    })

    this.updateSliderArrows(this.splide.index)
    this.updateScrollbar(this.splide.index)
  }

  // スライダー矢印
  sliderPrev() {
    if (this.splide) {
      this.splide.go('<')
    }
  }

  sliderNext() {
    if (this.splide) {
      this.splide.go('>')
    }
  }

  updateSliderArrows(index) {
    if (this.hasSliderPrevTarget) {
      this.sliderPrevTarget.disabled = index === 0
    }
    if (this.hasSliderNextTarget) {
      this.sliderNextTarget.disabled = index >= this.maxSliderIndex
    }
  }

  // スクロールバー
  updateScrollbar(index) {
    if (!this.hasScrollbarThumbTarget) return

    if (this.maxSliderIndex <= 0) {
      this.scrollbarThumbTarget.style.width = '100%'
      this.scrollbarThumbTarget.style.left = '0%'
      return
    }

    const thumbWidth = 100 / (this.maxSliderIndex + 1)
    const thumbLeft = (index / this.maxSliderIndex) * (100 - thumbWidth)

    this.scrollbarThumbTarget.style.width = `${thumbWidth}%`
    this.scrollbarThumbTarget.style.left = `${thumbLeft}%`
  }

  // モーダル開閉
  openModal(event) {
    const card = event.currentTarget
    const index = parseInt(card.dataset.staffIndex, 10)
    this.showSlide(index, false)
    this.modalTarget.classList.add('is-open')
    document.body.style.overflow = 'hidden'
  }

  closeModal() {
    this.modalTarget.classList.remove('is-open')
    document.body.style.overflow = ''
  }

  closeOnEscape(event) {
    if (event.key === 'Escape' && this.modalTarget.classList.contains('is-open')) {
      this.closeModal()
    }
  }

  // モーダルスライド
  modalPrevSlide() {
    if (this.currentIndex > 0) {
      this.showSlide(this.currentIndex - 1)
    }
  }

  modalNextSlide() {
    if (this.currentIndex < this.totalValue - 1) {
      this.showSlide(this.currentIndex + 1)
    }
  }

  showSlide(index, animate = true) {
    this.modalSlideTargets.forEach((slide, i) => {
      if (!animate) {
        slide.classList.add('no-transition')
      }

      slide.classList.remove('is-active', 'is-prev', 'is-next')

      if (i === index) {
        slide.classList.add('is-active')
      } else if (i < index) {
        slide.classList.add('is-prev')
      } else {
        slide.classList.add('is-next')
      }

      if (!animate) {
        requestAnimationFrame(() => {
          slide.classList.remove('no-transition')
        })
      }
    })

    this.currentIndex = index
    this.updateModalArrows()
  }

  updateModalArrows() {
    if (this.hasModalPrevTarget) {
      this.modalPrevTarget.disabled = this.currentIndex === 0
    }
    if (this.hasModalNextTarget) {
      this.modalNextTarget.disabled = this.currentIndex === this.totalValue - 1
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('staff-introduction', StaffIntroductionController)
